<template>
  <div class="text-caption__container">
    <div class="text-caption__name-tag" :style="{ display: nameTag === '' ? 'none' : 'flex' }">
      <div>{{ nameTag }}</div>
    </div>
    <div id="typewriter"></div>
  </div>
</template>

<script>
import Typewriter from "typewriter-effect/dist/core";

export function randomString(length = 10) {
  const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let result = "";
  for (let i = 0; i < length; i++) {
    result += charset.charAt(Math.floor(Math.random() * charset.length));
  }
  return result;
}

const delayFunc = async (millis) => new Promise((resolve) => setTimeout(resolve, millis));

export default {
  data() {
    return {
      nameTag: "",
    };
  },
  methods: {
    play(textSchemas, nameTag = { text: "", style: {} }) {
      const id = randomString(20);

      this.nameTag = nameTag.text;
      this.$el.classList.add("active");
      this._endMap = {};
      this._endMap[id] = async () => {
        this.$emit("captionEnd");
        // 여기서 fadeout
        this.$el.classList.add("fade-out");

        // delay
        await delayFunc(500);
        this.$el.classList.remove("active");
        this.$el.classList.remove("fade-out");
      };

      /* TODO: array 재생으로 만들기 */
      const textSchema = textSchemas[0];

      const $el = this.$el.querySelector("#typewriter");

      const typeWriter = new Typewriter($el, {
        loop: false,
        autoStart: false,
        cursor: "",
        delay: 30, // natural 75
      });

      typeWriter
        .typeString(textSchema.text)
        .start()
        .pauseFor(1000)
        .callFunction(() => {
          if (this._endMap[id]) this._endMap[id]();
        });
    },
    stop() {
      this._endMap = {};
      this.$el.classList.remove("active");
      this.$el.classList.remove("fade-out");
    },
  },
};
</script>

<style scoped>
.text-caption__container {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);

  position: relative;
  display: none;
}
.text-caption__container.active {
  display: block;
  animation: fadeIn 1s;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.text-caption__container.fade-out {
  animation: fadeOut 0.5s;
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.text-caption__name-tag {
  --name-tag-height: 40px;

  position: absolute;
  top: calc(-1 * var(--name-tag-height) / 2);
  left: 0;
  width: fit-content;
  height: var(--name-tag-height);
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 10px;
  padding-right: 10px;

  border-radius: calc(var(--name-tag-height) / 2);

  color: white;
  background-color: blue;
}

#typewriter {
  padding-top: 20px;
  padding-bottom: 10px;

  padding-left: 10px;
  padding-right: 10px;

  /*  */
  font-size: 24px;
  line-height: 1.5;
  color: white;
}
</style>
